module.exports = __webpack_public_path__ + "img/logo_umbrella_.d7260c83.png";